import React from 'react'

const shelter_availability_card = ({shelters}) => {
  return (
    <div className="p-2 card">
      <h3 className="text-center">Shelter Bed Availability</h3>
      {shelters.map(shelter => (
        <div key={shelter.name}>  
          <h5>{shelter.name}</h5>
          {
            Object.keys(shelter.inventories).map((inventory, index) => (
              <p style={{marginBottom:0}} key={index}>{shelter.inventories[inventory].name}: {shelter.inventories[inventory].count}</p>
            ))
          }
        </div>
      ))}
    </div>
  )
}

export default shelter_availability_card